<template>
  <web-component-loader v-if="stage" name="sccs-compare-checkbox" :environment="stage">
    <div class="compare-checkbox">
      <sccs-compare-checkbox
        :commission-number="commissionNumber"
        :product-code="code"
        :image-url="image"
        :name="name"
      />
    </div>
  </web-component-loader>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { getAemEnvironmentVariables } from '../../../utils/aem.util';

export default defineComponent({
  name: 'CompareCheckbox',
  props: {
    code: {
      type: String,
      required: true,
    },
    commissionNumber: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
});
</script>

<script lang="ts" setup>
const stage = ref<string | null>(null);

// This is the environment(tes/int/pprod/prod) the application is currently deployed.
getAemEnvironmentVariables().then((variables) => {
  stage.value = variables.stage;
});
</script>

<style lang="scss">
.compare-checkbox {
  @include wb-spacing('margin-bottom', 'xs');

  margin-top: 8px;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
